<template>
    <div id="insertPictureDialog" v-show="show">
        <CommonDialog v-show="show" :title="title" @close="handleCancel">
            <template v-slot:msg>
                <span class="dialog-message">{{ message }}</span>
            </template>
            <template v-slot:buttons>
                <div class="button-slot button-group" style="margin-bottom: 15px;">
                    <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(cancelBtnColor)" @click="handleCancel">
                        {{ cancelTxt }} </div>
                    <div class="btn-txt dialog-btn" :class="buttonBackgroundColor(confirmBtnColor)" @click="handleConfirm">
                        {{ confirmTxt }}</div>
                </div>
            </template>
        </CommonDialog>
        <input ref="fileInputEl" type="file" name="file" accept="image/*" autofocus="true" @change="changeImg">
        <img ref="fileImgEl" src="" href="#" id="fileImg" alt="沒有圖片，請重新讀取。">
    </div>
</template>

<script>
import AppRenderer from '../js/app_renderer';
import EventBus from '../js/event_bus';
import { READ_FILE, READ_FILE_AS_DATA_URL } from '../js/common/read_file';
import { RANDOM_CHAR } from '../js/common/random_char';
import ImageControl from '../js/record_task/image_control';
import { store } from '../store';
import { VIEW_TYPE } from '../js/view_type';
import CommonDialog from './dialogs/Dialog.vue';
import { buttonBackgroundColor } from '../js/dialog/dialog_button';

export default {
    data: function () {
        return {
            show: false,
            imgBlob: null,
            imgObjUrl: "",
            curPointer: null,
            curInsertPicture: null,
            limitImageSize: 512000,
            title: "提示",
            message: "確定要新增圖片?",
            confirmTxt: "選擇圖片",
            cancelTxt: "取消",
            confirmBtnColor: "orange",
            cancelBtnColor: "blue",
            buttonBackgroundColor
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        imgOverSize() {
            EventBus.getInstance().getAppRefs().alertDialog.showDialog(
                "提示",
                "圖檔超過500KB無法存入紀錄，建議您將圖檔壓縮後再使用，謝謝"
            )
        },
        async changeImg() {
            let fileEl = this.$refs.fileInputEl;
            let imgEl = this.$refs.fileImgEl;
            this.imgBlob = fileEl.files[0];

            // console.log("this.$refs.fileInputEl::", this.$refs.fileInputEl.files[0]);
            const size = this.$refs.fileInputEl.files[0].size;
            if (size > this.limitImageSize) {
                imgOverSize();
            } else {
                AppRenderer.Instance.getCopiedImage(fileEl.files[0], this.curPointer);
                fileEl.value = "";
            }

        },
        setInsertPicture(newInsertPicture) {
            this.curInsertPicture = newInsertPicture;
        },
        setPointer(newPointer) {
            this.curPointer = newPointer;
        },
        clearData() {
            this.curInsertPicture.createInsertPicture(null, null);
            this.curInsertPicture = null;
            this.curObjImg = null;
            this.$refs.fileInputEl.value = "";
            this.curPointer = "";
            this.imgBlob = null;
            this.imgObjUrl = null;
        },
        clickFileInputEl() {
            this.show = true;
        },
        setImage(src, fileName) {
            this.curInsertPicture.createInsertPicture(src, this.curPointer, fileName);
        },
        handleCancel() {
            this.show = false;
        },
        handleConfirm() {
            this.show = false;
            switch (store.nowView) {
                case VIEW_TYPE.PC:
                case VIEW_TYPE.MAC:
                case VIEW_TYPE.WEB:
                    this.$refs.fileInputEl.click();
                    const userAgent = navigator.userAgent;
                    if (/iPad|iPhone|iPod/i.test(userAgent)) {
                        // 如果當前瀏覽器運行的裝置是ios，需要再執行一次
                        this.$refs.fileInputEl.click();
                    }
                    break;
                case VIEW_TYPE.ANDROID:
                    JSInterface.chooseImage(this.limitImageSize.toString());
                    break;
                case VIEW_TYPE.IOS:
                    window.webkit.messageHandlers.chooseImage.postMessage(this.limitImageSize.toString());
                    break;
                default:
                    break;
            }
        }
        //==============
        // insertPicture(imgObjUrl, args) {

        //   if (imgObjUrl == null || args == null) return;

        //   let newX = args.x;
        //   let newY = args.y;
        //   let canvas = PainterProxy.getInstance().getCurrentPainter().painter.canvas;
        //   let toolBase = new ToolBase(PainterProxy.getInstance().getCurrentPainter().painter);


        //   fabric.Image.fromURL(imgObjUrl, (objImg) => {

        //     objImg.set({
        //       left: newX,
        //       top: newY,
        //       controls: Object.assign(toolBase.getBasicControls(), {
        //         mtr: toolBase.getTouchRotateControl({
        //           x: 0.5,
        //           y: 0,
        //           offsetX: 25,
        //           offsetY: 0,
        //         }),
        //         deleteControl: toolBase.getDeleteControl({
        //           x: 0.5,
        //           y: -0.5,
        //           offsetX: 25,
        //           offsetY: 0,
        //         }),
        //       })
        //     });

        //     objImg.hasControls = true;
        //     objImg.subTargetCheck = true;
        //     objImg.hasBorders = true;

        //     canvas.add(objImg);
        //     canvas.renderAll();

        //   }, {
        //     tag: DEFINE.TAG.INSERT_PICTURE + new Date().getTime(),
        //     url: imgObjUrl,
        //     point: {
        //       x: newX,
        //       y: newY
        //     }
        //   });
        // }
    },
    mounted: function () {
        window.insertPictureDialog = this;
    }
}



</script>

<style scoped>
#insertPictureDialog {
    position: absolute;
    z-index: var(--z-index-insert-picture);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 50vh;
    width: 80vw;
    max-width: 505px;
    max-height: 209px;
}

#insertPictureDialog>input[type="file"] {
    display: none;
}

#insertPictureDialog>img {
    display: none;
}

#trashImgEl {
    position: absolute;
}
</style>